import { ContractorTodoView } from "../components/ContractorTodoView";

/**
 * Portal podwykonawcy — strona „Moje terminy": kamienie milowe i terminy końcowe
 * wszystkich aktywnych zamówień firmy w jednym zestawieniu wg pilności
 * (zgłoszenie: projektant ma widzieć na szybko, co jest pilne, a co po terminie).
 */
export function ContractorTodoPage() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Moje terminy</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Kamienie milowe i terminy końcowe ze wszystkich aktywnych zamówień, od najpilniejszych.
        </p>
      </div>
      <ContractorTodoView />
    </div>
  );
}
